import { v4 as uuidv4 } from "uuid";
import { z } from "zod";
const FormFieldType = {
  Dropdown: "dropdown",
  TextInput: "text_input"
};
const allFormFieldTypes = [
  FormFieldType.Dropdown,
  FormFieldType.TextInput
];
const formFieldTypeSchema = z.enum(allFormFieldTypes);
const baseFormFieldSchema = z.object({
  /** Unique identifier for the form field. We should assume it's unique to the form only, even though in practice it's a UUID. */
  id: z.string(),
  type: formFieldTypeSchema,
  label: z.string(),
  target_custom_field_definition_id: z.string().nullish()
});
const dropdownFormFieldSchema = baseFormFieldSchema.extend({
  type: z.literal(FormFieldType.Dropdown),
  options: z.array(z.object({ value: z.string() }))
});
const textInputFormFieldSchema = baseFormFieldSchema.extend({
  type: z.literal(FormFieldType.TextInput)
});
const formFieldSchema = z.discriminatedUnion("type", [
  dropdownFormFieldSchema,
  textInputFormFieldSchema
]);
function generateFormFieldId() {
  return uuidv4();
}
const formSubmissionSchema = z.object({
  form_id: z.string(),
  values: z.array(
    z.object({
      field_id: z.string(),
      field_label: z.string(),
      value: z.unknown()
    })
  )
});
export {
  FormFieldType,
  allFormFieldTypes,
  formFieldSchema,
  formFieldTypeSchema,
  formSubmissionSchema,
  generateFormFieldId
};
//# sourceMappingURL=form.js.map
